export default {
    getSessaoAgendamentoOnline(){
        return localStorage.getItem('sessaoAgendamentoOnline');
    },
    setSessaoAgendamentoOnline(sessaoAgendamentoOnline){
        if (sessaoAgendamentoOnline)
            localStorage.setItem('sessaoAgendamentoOnline', sessaoAgendamentoOnline);
        else
            localStorage.removeItem('sessaoAgendamentoOnline');
    },

    getAgendamentoGuardado(){
      return JSON.parse(localStorage.getItem('agendamentoGuardado'));
    },
    setAgendamentoGuardado(agendamentoGuardado){
        if (agendamentoGuardado)
            localStorage.setItem('agendamentoGuardado', JSON.stringify(agendamentoGuardado));
        else
            localStorage.removeItem('agendamentoGuardado');
    }
}
